import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import { mediaQueries } from '@general/breakpoints';
import colors from '@general/colors';
import SearchBox from '../../elements/SearchBox';
import SearchTypeToggle from '../../elements/SearchTypeToggle';
import { AttendeeModeContext } from '../../../context/searchContext';

const HeaderEvent = styled.h1`
    margin-top: 0;
    @media ${mediaQueries.md} {
        margin-top: -40px;
    }
`;

const Hero = ({ onSearchTypeChange }) => {
    const [query, setQuery] = useState();
    const { isAttendeeSearch, eventName, eventDate } = useContext(AttendeeModeContext);

    const handleChange = event => {
        setQuery(event.target.value || '');
    };

    const bgColor = '#000';
    const bgCover = 'cover';
    const bgImage = '/assets/images/pattern-primary4.svg';

    return (
        <div
            className={`jumbotron jumbotron-fluid m-0 p-0 results-hero'}`}
            style={{ backgroundImage: `url(${bgImage})`, backgroundColor: bgColor, backgroundSize: bgCover }}
        >
            <div className="container pt-3 pb-4 py-md-6">
                <div className="row">
                    <div className="col">
                        {isAttendeeSearch && eventName && (
                            <>
                                <HeaderEvent className="display3 light bold text-center mb-3">{eventName}</HeaderEvent>
                                <h2 className="hero-desc lead light mb-4 text-center display4">{eventDate}</h2>
                            </>
                        )}

                        <SearchTypeToggle onSearchTypeChange={onSearchTypeChange} />

                        <SearchBox
                            debounceTime={400}
                            defaultRefinement={query}
                            placeholder="Search for..."
                            onChange={handleChange}
                            onReset={handleChange}
                        />

                        {query && (
                            <h1 className="mb-0 mt-4 mt-md-5 text-center" style={styles.queryDisplay}>
                                "{query}"
                            </h1>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    queryDisplay: {
        color: colors.white,
    },
};

Hero.propTypes = {
    onSearchTypeChange: PropTypes.func,
};

export default Hero;
